import axios from 'axios';

// Use relative URL for same-origin deployment (nginx proxies /api to backend)
// If REACT_APP_BACKEND_URL is set, use it; otherwise use relative path
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: BACKEND_URL ? `${BACKEND_URL}/api` : '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      delete api.defaults.headers.common['Authorization'];
      // Only redirect if not already on auth/public pages. The marketing homepage ("/" and
      // its "/home-preview" alias) must never bounce a visitor to login on a stale token.
      const path = window.location.pathname;
      const onPublicPage =
        path === '/' ||
        path === `${process.env.PUBLIC_URL}/` ||
        path.includes('/home-preview') ||
        path.includes('/login') ||
        path.includes('/register') ||
        path.includes('/admin') ||
        path.includes('/explore') ||
        path.includes('/commission');
      if (!onPublicPage) {
        window.location.href = `${process.env.PUBLIC_URL || ''}/login`;
      }
    }
    return Promise.reject(error);
  }
);

export default api;
